import { render, staticRenderFns } from "./WariWariGameInfo.vue?vue&type=template&id=ef68f0fa&"
import script from "./WariWariGameInfo.vue?vue&type=script&lang=js&"
export * from "./WariWariGameInfo.vue?vue&type=script&lang=js&"
import style0 from "./WariWariGameInfo.vue?vue&type=style&index=0&id=ef68f0fa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports